module.exports = __webpack_public_path__ + "img/logo-lyon.b2e94088.png";